<div class="search-bar full-width">
  <input class="full-width" type="text" readonly [ngClass]="{'pointer': !disabledProperty && !!settings}"
    [placeholder]="!!settings.placeholder && !disabledProperty ? settings.placeholder : ''" [(ngModel)]="valueToView"
    [disabled]="disabledProperty || !settings" (mouseenter)="inputOnHover = true" (mouseleave)="inputOnHover = false"
    (click)="onClickInput($event)" />
  @if(!!valueToView && !disabledProperty){
  <i class="fa fa-times" (click)="onClearSelected($event)"></i>
  }
  @if(!valueToView && !disabledProperty){
  <i class="fa fa-caret-down" [ngClass]="{'disabled': disabledProperty}"></i>
  }
  @if(showOptions && settings){
  <div class="options-container" [ngClass]="{'bottom': bottomHalf}">
    <bt-loader [loaderId]="loaderId">
      <input class="full-width" type="text" placeholder="Search..." [(ngModel)]="searchText"
        (ngModelChange)="onFilterChange()" (click)="$event.stopPropagation()" />
      @if(datasourceCopy?.length){
      <div class="overflow-container">
        @for(item of datasourceCopy; track item){
        <div class="pointer padding-small hover" inViewport (inViewportAction)="inViewportAction($event, item)"
          (click)="onSelect($event, item)">
          {{settings.stringsDs ? item : item[settings.textProperty]}}
        </div>
        }
      </div>
      }
      @if(datasourceCopy && !datasourceCopy.length){
      <div class="padding align-center" (click)="showOptions = false">
        There are no data
      </div>
      }
    </bt-loader>
  </div>
  }
</div>